/* eslint-disable react/no-danger */
import React from 'react'
import classes from '@src/styles/disposal/feature-grid.module.css'

export type FeatureGridItem = {
  heading: string
  content: string
  /** Icon image path/URL. Omit to render the tile without an icon. */
  icon?: string
  /** Overrides the default empty (decorative) alt text — the heading carries the meaning. */
  iconAlt?: string
}

export type FeatureGridProps = {
  heading: string
  subHeading?: string
  list: FeatureGridItem[]
  className?: string
}

/**
 * Icon-tile variant of {@link FeatureList} — the port of the app repo's
 * `style: "graphics"` FeatureList branch, used by the composting pages for the
 * "Composting with Dimension" and "What Can Be Composted?" sections.
 *
 * The grid is two columns on desktop because the ported sections carry
 * paragraph-length copy per tile; it collapses to one column under 991px.
 */
function FeatureGrid({ heading, subHeading, list, className }: FeatureGridProps) {
  return (
    <section className={className}>
      <div className={classes.container}>
        <h2 className={classes.title} dangerouslySetInnerHTML={{ __html: heading }} />
        {subHeading && <p className={classes.subTitle}>{subHeading}</p>}
        <ul className={classes.grid}>
          {list.map((item) => (
            <li key={item.heading} className={classes.tile}>
              {item.icon && (
                <img className={classes.icon} src={item.icon} alt={item.iconAlt ?? ''} />
              )}
              <h3 className={classes.tileHeading}>{item.heading}</h3>
              <p className={classes.tileContent}>{item.content}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default FeatureGrid
